import React, { useEffect, useState } from 'react';
import { LocumSearchProvider } from '../../../context/LocumSearchContext';
import FindLocumContent from './FindLocumContent';
import { useSubscriptionAccess } from '../../../components/Subscription/SubscriptionAccessProvider';
import { PrimaryButton } from '../../../components/Button/PrimaryButton';
import Page from '../../../components/Page/Page';
import PageBanner from '../../../components/Banner/PageBanner';

const FindLocum = () => {
  const { requireFeature } = useSubscriptionAccess();
  const [allowed, setAllowed] = useState(false);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    let mounted = true;
    void requireFeature('canUseFindLocum').then(result => {
      if (mounted) { setAllowed(result); setChecking(false); }
    });
    return () => { mounted = false; };
  }, [requireFeature]);
  if (checking) return <p role="status">Checking Find a Locum access...</p>;
  if (!allowed) return <Page title="Locumspace | Find a locum"><section style={{ padding: 24 }}>
    <PageBanner label="Find a Locum" description="Discover healthcare professionals available for work." />
    <p>Access depends on your subscription. Your menu and existing job records remain available.</p>
    <PrimaryButton click={async () => setAllowed(await requireFeature('canUseFindLocum'))}>
      View access options
    </PrimaryButton>
  </section></Page>;
  return (
    <LocumSearchProvider>
      <FindLocumContent />
    </LocumSearchProvider>
  );
};

export default FindLocum;
